import { ApplicationState } from '@/store';
import { Flex, Box, VStack } from '@chakra-ui/react';
import { TableCellProps } from '../../../types';
import { EApplicationPGKeys } from 'types';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { memo } from 'react';
import { DefaultDashboardTabIds } from 'data';
import { useSelector } from 'react-redux';
import { UNKNOWN_VALUE } from '../helpers';
import { faRotateExclamation } from '@fortawesome/pro-regular-svg-icons';
import { RoundBadgeWithTooltip } from 'shared-components';

const Formatter = memo(function formatter(cellProps: TableCellProps) {
  const activeTab = useSelector(({ offersDashboard }: ApplicationState) => offersDashboard.currentTab);
  const isLeadStage = activeTab === DefaultDashboardTabIds.LEADS;

  // Get display value based on stage
  const getDisplayValue = () => {
    if (isLeadStage) {
      const knownBy = cellProps?.row?.knownBy || '';
      const email = cellProps?.row?.email || '';
      return knownBy && email
        ? `${knownBy} (${email})`
        : knownBy ||
            email ||
            `${cellProps?.row?.givenName || UNKNOWN_VALUE} ${cellProps?.row?.familyName || UNKNOWN_VALUE}`;
    }
    return `${cellProps?.row?.givenName ?? UNKNOWN_VALUE} ${cellProps?.row?.familyName ?? UNKNOWN_VALUE}`;
  };

  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      <VStack spacing="2" display="flex" alignItems="flex-start" justifyContent="flex-start" height="100%" py={4}>
        <Flex width={'100%'} justifyContent="end">
          {cellProps.row.potentialDuplicate && (
            <RoundBadgeWithTooltip
              label="Potential duplicates on your student management system"
              colorScheme="red"
              variant="solid"
              size="xs"
              icon={faRotateExclamation}
            />
          )}
        </Flex>

        <Box fontWeight="medium" className="namesContainer">
          {getDisplayValue()}
        </Box>
      </VStack>
    </Flex>
  );
});

export const StudentColumn = (): IColumn => ({
  item: {
    key: EApplicationPGKeys.FAMILY_NAME,
    name: 'Student',
    sortable: true,
    width: 'minmax(304px, 2.5fr)',
    frozen: true,
    formatter: Formatter,
    headerRenderer: defaultHeaderRenderer,
  },
  visible: () => true,
});
